module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('BreadcrumbItem', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "social-buffer-outline"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("系统管理")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d68c4e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SystemManage/index.vue
// module id = 917
// module chunks = 1